import apiUrl from '../../../constants'
import axios from 'axios'
import { BasicSelect } from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import moment from 'moment';

export default {
    name: 'CheckNdrNprVerification',
    components: {
        BasicSelect,
        Paginate,
        VueElementLoading
    },
    mixins:[PageTracker],
    data: function() {
        return {
          pageno: "1",
          pagecount: 1,
          isLoading:false,
          type:'',
          selectedTypeObj:{},
          typeList:[
            {
              text:'SR',
              value:'1'
            },
            {
              text:'Shipment',
              value:'2'
            }
          ],
          shippingId:'',
          srId:'',
          ndpNprListData:[],
          showTable:false,
          userDataKey : '',
        }
     },
async mounted(){
  this.userDataKey = window.localStorage.getItem('userUniqueKey');
  let validateUser = await this.validateJwtToken();
  var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
  var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  var userdetail = JSON.parse(plaintext)
  this.createdBy = userdetail.username;
  this.userid = userdetail.userid;
},
filters: {
  changeDateFormat: function(date) {
    if (date != null || date != '') {
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  }
},
methods : {

    afterTypeSelected(obj){
      this.showTable = false;
      this.selectedTypeObj = obj
      this.type = obj.value
      this.srId ? this.srId = '': '';
      this.shippingId ? this.shippingId = '': '';
      this.$validator.reset();
    },
    // getPaginationData(pageNum) {
    //   this.pageno = pageNum
    //   this.formSubmit();
    //   },
    formSubmit(scope) {
      this.$validator.validateAll(scope).then(result=> {
          if(result) {
            this.isLoading = true;
            this.showTable = true;
            this.ndpNprListData.length ? this.ndpNprListData = '' : '';

            let ndrNprPayload;
                if (this.type === '1') {
                  ndrNprPayload = {
                    type: 'SR',
                    SRId: this.srId
                  }
                }else {
                  ndrNprPayload = {
                    type: 'Shipment',
                    ShippingId: this.shippingId
                  }
                }
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'websupport/check/ndr/npr/verification',
              data: ndrNprPayload
            })
            .then(result => {
              this.isLoading = false;
                if(result.data.code == 200) {
                  this.ndpNprListData = result.data.data
                } else {
                  this.$alertify.error(result.data.message);
                  this.showTable = false;
                  return false;
                }
              }, error => {
                this.isLoading = false;
                console.error("Exception is:::::::::", error)
              })
            }
          })
        },
        resetForm(){
          if (this.type === '1') {
            this.srId = ''
          }else if(this.type === '2'){
            this.shippingId = '';
          }
          this.ndpNprListData = []
          this.selectedTypeObj={}
          this.type = ''
          this.showTable = false;
          this.$validator.reset();
          // this.errors.clear();
          }
      }
    }



// WEBPACK FOOTER //
// ./src/views/components/CheckNdrNprVerification/CheckNdrNprVerification.component.js